             <nav  (click)="hidethenav()"  class="navbar navbar-expand-sm bg-dark navbar-dark fixed-top">  
                <div *ngIf="message"  [ngClass]="{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }">{{message.text}}</div>
              </nav>
